import "./ParentTeacherAssociation.scss";
import AboutUsDynamicPage from '../../Administration Dynamic Page/AdministrationdynamicPage';
import TableComponent from '../../../components/Table/TableComponent';
import administration from "../../Administration.json";

const ParentTeacherAssociation = () => {

    const parentTeacherAssociationPage = administration.parentTeacherAssociation[0];
    const columns = ["S.No.", "Name", "Designation", "Position"];
    const rows = [
        { name: "Dr. R. Marimuthu", designation: "Principal", position: "Chairman " },
        { name: "Dr. R. P. Dhanya", designation: "Asst. Prof. & Head, Department of Microbiology", position: "Member" },
        { name: "Dr. Ciby S. Kumar", designation: "Asst. Prof. & Head, Department of Visual Communication", position: "Member" },
        { name: "Mrs. T. Mabel", designation: "Asst. Prof., Department of Computer Application", position: "Member"},
        { name: "Mrs. T. Sheeba", designation: "Asst. Prof. & Head, Department of  Microbiology", position: "Member"},
        { name: "Mrs. T. D. Jeba Freeda", designation: "Asst. Prof., Department of Computer Science", position: "Member"}
    ];

    return (
        <section className="parentTeacherAssociationMainContainer">
            <AboutUsDynamicPage
                title={parentTeacherAssociationPage.title}
                content={parentTeacherAssociationPage.content}
            />
            <TableComponent
                columns={columns}
                data={rows}
                title="Parent Teacher Association Member"
                gap='20px'
            />
        </section>
    )
}

export default ParentTeacherAssociation
